var map = {
	"./bmp": 57154,
	"./bmp.js": 57154,
	"./gif": 59503,
	"./gif.js": 59503,
	"./jpg": 96938,
	"./jpg.js": 96938,
	"./png": 86330,
	"./png.js": 86330,
	"./psd": 48054,
	"./psd.js": 48054,
	"./svg": 11971,
	"./svg.js": 11971,
	"./tiff": 23678,
	"./tiff.js": 23678,
	"./webp": 9327,
	"./webp.js": 9327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8560;